import { useMutation } from '@apollo/client';
import { DeleteActionsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import { evictField } from '@/utils/graphqlUtils';

import { useDeleteActionsTRPC } from './useDeleteActionsTRPC';

export const useDeleteActions = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  // GraphQL mutation
  const [deleteActionsGraphQL, graphqlState] = useMutation(
    DeleteActionsDocument,
    {
      update: (cache) => {
        evictField(cache, 'action');
        evictField(cache, 'action_aggregate');
      },
    }
  );

  // tRPC mutation
  const trpcMutation = useDeleteActionsTRPC();

  const deleteActions = async (variables: { Ids: string[] }): Promise<void> => {
    if (trpcEnabled) {
      return trpcMutation.deleteActions(variables);
    }

    const result = await deleteActionsGraphQL({
      variables: {
        Ids: variables.Ids,
      },
    });

    if (!result.data) {
      throw new Error('Failed to delete actions');
    }
  };

  // Return appropriate state based on feature flag
  if (trpcEnabled) {
    return {
      deleteActions,
      loading: trpcMutation.loading,
      error: trpcMutation.error,
    };
  }

  return {
    deleteActions,
    loading: graphqlState.loading,
    error: graphqlState.error,
  };
};
